import React from 'react';
import {NeuroMessage, TransitionContainer, useNeuroState} from "@ignitesales/neuro-application";
import {GuideNameMessage, useDialogueContext} from "../../../../../../shared/js";

const ImagePanel = () => {
    const { sidebarImageId } = useNeuroState();
    const { getPagePathMessageId } = useDialogueContext();
    const messageId = getPagePathMessageId();
    const componentClass = "imagePanel";

    return <div className={componentClass}>
        <div className="titleSection">
            <GuideNameMessage />
        </div>
        <div className="imageSection">
            <TransitionContainer className="sidebarImgTransitionContainer" transitionKey={sidebarImageId}>
                <div className="img" style={{ backgroundImage: `url('/classpath/assets/images/theme-images/${sidebarImageId}.jpg')` }} />
            </TransitionContainer>
            <TransitionContainer className="sidebarTransitionContainer" transitionKey={messageId}>
                <div className={`${componentClass}__text`}>
                    <NeuroMessage id={messageId} tagName="h4" shouldHideIfNotFound={true} />
                </div>
            </TransitionContainer>
        </div>
    </div>;
};

export default ImagePanel;
